module.exports = __webpack_public_path__ + "static/media/12.de4115cf.png";